
import { Injectable, Inject, Optional, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

        constructor(private router: Router, @Inject(PLATFORM_ID) private platformId: Object, @Optional() @Inject('REQUEST') private request: any) { }
    
        canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

            console.log("Checking the gcard");
            let hasAuth = false;

            if (isPlatformServer(this.platformId) && this.request) {
                const cookies = this.request.headers.cookie || '';
                hasAuth = cookies.includes('currentUser=') && cookies.includes('stcode=AT');
            } else {
                hasAuth = !!(localStorage.getItem('currentUser') && localStorage.getItem('stcode') == 'AT');
            }

            if (hasAuth) {
                console.log("Auth Pass");
                return true;
            }
            else{
                console.log("Auth fail");
                this.router.navigate(['/authentication/login/page'], { queryParams: { returnUrl: state.url }});
                return false;
            }
    

        }
    }